import styled from "styled-components";

const CenterArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default CenterArea;